module.exports = __webpack_public_path__ + "img/logo_07.6c153690.png";